import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';

export const useBrandName = () => useBusinessUnitContext().brandName;
